import anatomyNetworkPNG from '~/assets/images/anatomyV2/anatomy-network.png'
import anatomyNetworkWEBP from '~/assets/images/anatomyV2/anatomy-network.webp'
import InfoRevealTemplate from '~/pages/anatomyV2/libs/components/InfoRevealTemplate'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 4

const AnatomyNetworkAnatomyV2 = (props: TPageProps) => (
  <InfoRevealTemplate
    {...props}
    buttonI18nKey="onboarding.anatomyNetwork.button"
    buttonNs="anatomyV2"
    currentSection={SECTION_NUMBER}
    imageAlt="Brain and nervous system"
    imagePNG={anatomyNetworkPNG}
    imageWEBP={anatomyNetworkWEBP}
    paragraphI18nKeys={['onboarding.anatomyNetwork.paragraph']}
    question="Anatomy network intro viewed"
    titleI18nKey="onboarding.anatomyNetwork.title"
  />
)

export default AnatomyNetworkAnatomyV2
